import dayjs from "dayjs";
import { useWithdraws } from "../../store/useWithdraws";
import { Tooltip } from "@material-tailwind/react";
import { useAuth } from "../../store/useAuth";
export const UserWithdrawsTable = () => {
  /** Hooks */
  const { withdraws, refundWithdraw } = useWithdraws();
  const { user } = useAuth();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-3">
              Date created
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Amount
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Type
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Community
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-3">
              Status
            </th>
            {([1, 7].includes(Number(user?.user_role)) ? <th scope="col" className="px-2 sm:px-6 py-1 sm:py-3 text-right">
              Actions
            </th> : null)}
          </tr>
        </thead>
        <tbody>
          {withdraws?.map((withdraw) => {
            return (
              <tr
                key={withdraw?._id}
                className="bg-white border-b cursor-pointer hover:bg-gray-50"
              // onClick={openDropDetails}
              >
                <th
                  scope="row"
                  className="px-2 sm:px-6 py-1 sm:py-4 text-xs sm:text-base font-bold text-primary-base whitespace-nowrap"
                >
                  {dayjs(withdraw?.createdAt).format("DD-MM-YYYY HH:mm")}
                </th>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  {new Intl.NumberFormat("nl-NL", {
                    style: "currency",
                    currency: "EUR",
                  }).format(Number(withdraw?.amount ?? 0) / 100)}
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  {withdraw?.withdrawType === "community"
                    ? "Community"
                    : "Personal"}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4">
                  {/* @ts-ignore */}
                  {withdraw?.community?.name ?? "-"}
                </td>
                {
                  withdraw?.isDonation ? (<td className="px-2 sm:px-6 py-1 sm:py-4">
                    {withdraw?.status === "REDEEMED" && (
                      <span className="text-purple-700">Donation</span>
                    )}
                  </td>
                  ) : (<td className="px-2 sm:px-6 py-1 sm:py-4">
                    {withdraw?.status === "CREATED" && (
                      <span className="text-orange-500">Created</span>
                    )}
                    {withdraw?.status === "REDEEMED" && (
                      <span className="text-green-500">Redeemed</span>
                    )}
                    {withdraw?.status === "EXPIRED" && (
                      <span className="text-red-500">Expired</span>
                    )}
                    {withdraw?.status === "REFUNDED" && (
                      <span className="text-gray-500">Refunded</span>
                    )}
                  </td>
                  )
                }
                {(Number(user?.user_role) === 7 && !withdraw?.isDonation && (withdraw?.status === 'CREATED' || withdraw?.status === 'EXPIRED')) ? <td className="px-2 sm:px-6 py-1 sm:py-3 flex items-center justify-end cursor-pointer">
                  <Tooltip content="Refund">
                    <img onClick={() => {
                      const confirmRefund = window.confirm(
                        "Are you sure you want to refund this withdraw?"
                      );
                      if (confirmRefund) {
                        refundWithdraw(withdraw?._id)
                      }
                    }} alt="refund" src={require('../../assets/icons/tables/refund-icon.png')} className="w-5 h-5" />
                  </Tooltip>
                </td> : null}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
